export default __webpack_public_path__ + "static/media/ManThinks.22c92e66.svg";